import app from '../firebase';

let analyticsPromise = null;

const getAnalyticsInstance = () => {
  if (analyticsPromise) return analyticsPromise;
  analyticsPromise = import('firebase/analytics')
    .then(async ({ getAnalytics, isSupported }) => {
      if (!(await isSupported())) return null;
      return getAnalytics(app);
    })
    .catch(() => null);
  return analyticsPromise;
};

const roundMetricValue = (name, delta, value) => {
  const raw = name === 'CLS' ? delta * 1000 : delta ?? value;
  return Math.round(raw);
};

export const logWebVital = ({ name, delta, value, id, rating }) => {
  const metricValue = roundMetricValue(name, delta, value);

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(`[Web Vital] ${name}:`, metricValue, rating || '');
  }

  getAnalyticsInstance().then((analytics) => {
    if (!analytics) return;
    import('firebase/analytics').then(({ logEvent }) => {
      logEvent(analytics, 'web_vitals', {
        metric_name: name,
        metric_value: metricValue,
        metric_id: id,
        metric_rating: rating || '',
      });
    });
  });
};
